import { Empty } from "@/components/Empty";
import SubLayout from "@/components/SubLayout";
import { Payments } from "@/constants";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Process } from "./Process";
import { paymentsContent } from "./data";
import styles from "./index.module.scss";
export function PageSavePayQRCode() {
  const params = useParams<{
    type: string;
  }>();
  const active = useMemo(() => {
    return `${params.type}` || `${Payments.WE_CHAT}`;
  }, []);
  const content = useMemo(() => {
    return active && paymentsContent[(active as string)] ? paymentsContent[active] : null;
  }, [active]);
  return <SubLayout title={content?.title} data-sentry-element="SubLayout" data-sentry-component="PageSavePayQRCode" data-sentry-source-file="SavePayQRCode.tsx">
      <div className={styles.page}>
        {/* <CapsuleTabs activeKey={active}> */}
        <section className={styles.content_wrapper} key={content?.title}>
          <div className={styles.content_header}>
            <div className={styles.content_header_content}>
              <div className={styles.content_title_left}></div>
              <div className={styles.content_title}>
                {content?.title || "标题"}
              </div>
              <div className={styles.content_title_right}></div>
            </div>
          </div>

          <div className={styles.content_text}>
            {content ? <Process title={content?.title} steps={content?.steps} /> : <Empty />}
          </div>
        </section>
        {/* </CapsuleTabs> */}
      </div>
    </SubLayout>;
}